import React, { useEffect, useMemo, useState } from 'react'
import { Box, TextField } from '@mui/material'
import { ICourseNode } from './IngestedTree'
import { ISubject, subjectForCourse } from './Utility'
import { currentEnvironment, Environment } from 'infrastructure/api'

export interface IOverrides {
  subject?: string
  gradeId?: string
  environment?: Environment
}

export default function CurriculaOverrides({
  ingestion,
  onChange,
}: {
  ingestion: ICourseNode
  onChange: (values: IOverrides) => void
}) {
  const [thisSubject, setThisSubject] = useState<ISubject>()
  const [envOverride, setEnvOverride] = useState<string>('')
  const [overrideSubject, setOverrideSubject] = useState('')
  const [overrideGrade, setOverrideGrade] = useState('')

  useEffect(() => {
    if (!ingestion) return
    subjectForCourse(ingestion).then(setThisSubject)
  }, [ingestion])

  const currentEnvOverride: Environment | undefined = useMemo(() => {
    let environment = currentEnvironment()
    if (Object.values(Environment).includes(envOverride as Environment)) {
      environment = envOverride as Environment
    }
    return environment
  }, [envOverride])

  const currentGrade = useMemo(() => {
    return overrideGrade || ingestion?.data.gradeID + ''
  }, [ingestion, overrideGrade])

  const currentSubject = useMemo(() => {
    return overrideSubject || thisSubject?.subject_name
  }, [overrideSubject, thisSubject])

  const myCurrentEnvironment = useMemo(() => {
    return currentEnvOverride || currentEnvironment()
  }, [currentEnvOverride])

  useEffect(() => {
    onChange({
      environment: currentEnvOverride,
      subject: currentSubject,
      gradeId: currentGrade,
    })
  }, [currentEnvOverride, currentGrade, currentSubject, onChange])

  const OverrideComponent = ({ label }: { label: string }) => {
    return (
      <Box padding={'10px'} fontSize={12}>
        Overrides {label}
      </Box>
    )
  }
  const OverriddenSubject = () => {
    if (currentSubject === thisSubject?.subject_name) return null
    return (
      <OverrideComponent label={thisSubject?.subject_name || 'undefined'} />
    )
  }

  const OverriddenGrade = () => {
    if (currentGrade === ingestion?.data.gradeID + '') return null
    return <OverrideComponent label={ingestion?.data.gradeID + ''} />
  }

  const OverriddenEnvironment = () => {
    if (!envOverride || envOverride !== currentEnvironment()) return null
    return <OverrideComponent label={currentEnvironment() || ''} />
  }

  return (
    <Box>
      <Box>
        <b>Subject:</b> {currentSubject}{' '}
        <TextField onChange={(e) => setOverrideSubject(e.target.value)} />
        <OverriddenSubject />
      </Box>
      <Box>
        <b>GradeId:</b> {currentGrade}{' '}
        <TextField onChange={(e) => setOverrideGrade(e.target.value)} />
        <OverriddenGrade />
      </Box>
      <Box>
        <b>Environment</b> {myCurrentEnvironment}{' '}
        <TextField
          value={envOverride}
          onChange={(e) => setEnvOverride(e.target.value)}
        />
        <OverriddenEnvironment />
      </Box>
    </Box>
  )
}
